webpackJsonp([13],{

/***/ "Ahgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_i18n__ = __webpack_require__("rNh1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_router_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("vdRI");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'label' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.about' })
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'p',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.desc' })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  { 'class': 'social-networks clearfix' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'https://www.facebook.com/DolphNet.internet/', target: '_blank' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', 'class': 'icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', { xlinkhref: '/assets/img/icons.svg#facebook' })
      )
    )
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'https://twitter.com/dolphneti', target: '_blank' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', 'class': 'icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('use', { xlinkhref: '/assets/img/icons.svg#twitter' })
      )
    )
  )
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'label' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.support' })
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'li',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'a',
    { href: 'tel:+37169999999' },
    '+371-69-999-999'
  )
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.link' });

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'label' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.adres' })
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'ul',
  null,
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'span',
      { 'class': 'address' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.adresText' })
    )
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'li',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'a',
      { href: 'https://www.google.com/maps/place/DolphNet+internet/@56.9600007,24.0994507,17z/data=!3m1!4b1!4m5!3m4!1s0x46eecff6118e503d:0x59fce2c684aaab3a!8m2!3d56.9600007!4d24.1016394', target: '_blank', 'class': 'location' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.map' })
    )
  )
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'label' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.label' })
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.item' });

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.item2' });

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.item3' });

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.item4' });

var _ref14 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.services.item5' });

var _ref15 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'label' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.site.label' })
);

var _ref16 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.site.item' });

var _ref17 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.site.item2' });

var _ref18 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.site.item3' });

var _ref19 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.menu.site.item5' });

var _ref20 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'bottom' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    { 'class': 'container' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': 'copyright' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.copy' })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { 'class': 'desing-marketing' },
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.note' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        { href: 'https://www.alc.lv/', target: '_blank' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_1_preact_i18n__["c" /* Text */], { id: 'footer.noteLink' })
      )
    )
  )
);

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Footer.prototype.render = function render(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'footer',
      { id: 'footer' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { 'class': 'main' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { 'class': 'container' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { 'class': 'row' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': 'col about' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                { href: props.prefix + "/company" },
                _ref
              ),
              _ref2,
              _ref3
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': 'col contacts' },
              _ref4,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'ul',
                null,
                _ref5,
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/contact?form=true", 'class': 'subscription' },
                    _ref6
                  )
                )
              ),
              _ref7,
              _ref8
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': 'col' },
              _ref9,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'ul',
                { 'class': 'menu' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/internet" },
                    _ref10
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/telephone" },
                    _ref11
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/email" },
                    _ref12
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/hosting" },
                    _ref13
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/services" },
                    _ref14
                  )
                )
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { 'class': 'col' },
              _ref15,
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'ul',
                { 'class': 'menu' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/availability" },
                    _ref16
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'a',
                    { href: 'javascript:', onClick: function onClick() {
                        return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].showModal('login');
                      } },
                    _ref17
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/support" },
                    _ref18
                  )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                  'li',
                  null,
                  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    __WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
                    { href: props.prefix + "/privacy" },
                    _ref19
                  )
                )
              )
            )
          )
        )
      ),
      _ref20
    );
  };

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



/***/ })

});


// WEBPACK FOOTER //
// 13.chunk.99bdb.js